import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import classnames from 'classnames';
import { Background } from "../../Background/Background";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import styles from "./DirectorySlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var directoryBgColors = ['none', '#FFFFFF' // WW500
];
export var DirectorySlice = function DirectorySlice(_ref) {
  var align = _ref.align,
    background = _ref.background,
    directory = _ref.directory,
    footnote = _ref.footnote,
    heading = _ref.heading,
    ListComponent = _ref.ListComponent;
  var renderDirectoryItems = function renderDirectoryItems() {
    return directory === null || directory === void 0 ? void 0 : directory.map(function (item, key) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.directoryItem,
        children: /*#__PURE__*/_jsx(ListComponent, _objectSpread({}, item))
      }, key);
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.directory, styles["directoryAlign".concat(_capitalize(align))]),
    children: /*#__PURE__*/_jsxs(Background, {
      color: background,
      children: [(heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_jsx(HeadingText, {
        className: styles.directoryHeadline,
        ariaLevel: heading.ariaLevel,
        typog: heading.typog,
        variant: heading.variant,
        children: heading.text
      }, 'heading'), /*#__PURE__*/_jsx("div", {
        className: styles.directoryList,
        children: renderDirectoryItems()
      }), footnote && /*#__PURE__*/_jsx("div", {
        className: styles.directoryFootnote,
        children: /*#__PURE__*/_jsx(Text, {
          typog: "captionSmall",
          className: styles.directoryFootnoteText,
          children: footnote
        })
      })]
    })
  });
};